import React from 'react';
import PropTypes from 'prop-types';

import MotifBadge from '@ey/motif-react-wrapper/Badge';

const Badge = ({...rest}) => <MotifBadge {...rest} />;

Badge.propTypes = {};

export default Badge;
